import { Ubicacion } from "../Ubicacion"

const Region = () => {
  return (
    <>
      <Ubicacion
        nivel={2}
        descripcion="Regiones"
        comboDescripcion="Tajo:"
        comboNivel={1}
      />
    </>
  )
}

export { Region }